module.exports = __webpack_public_path__ + "static/media/image-card-3.d1061da7.png";